import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  company: [],
  isLoading: false,
  error: null,
  countries: [],
  countriesIsLoading: false,
  countriesError: null,

  cityBycountries: {},
  isErrcityBycountries: null,
  isLoadingcityBycountries: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/company/index.js